export const TooltipTitles = {
  viewAudience: 'Check details with which your file is locked.',
  editAudience: 'Update locking criteria for your file.',
  analytics: 'We are working on this feature (stay tuned).',
  chatTab: 'Surprise for you (Coming Soon)',
  myFiles: 'See all your uploaded files here',
  manageAccessPermission:
    'Set who can view your file by using blockchain based parameters like tokens',
  useNFTAndTokens:
    'You can use NFTs and Tokens that you own to lock this file.',
  listOfAddresses: 'Mint and distribute access tokens instantly.',
  setAccess: 'Set access to who can view your file',
  YourAccessNFTs:
    'Here you can see & click on all the Access NFTs you have received. These are ERC-721 tokens that grant you access to specific files on Fileverse.',
  ProfilePageUploadZone:
    'Just upload and share files with your wallet, your peers, your rules! You upload, we encrypt, IPFS stores.',
};
